import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import { amxPalette } from "../ThemeProvider";

export const AmxTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > div": {
      width: "100%",
      backgroundColor: amxPalette.grey.main,
    },
  },
})((props) => {
  return (
    <Tabs
      {...props}
      TabIndicatorProps={{ children: <div /> }}
      variant={props.variant ? props.variant : "fullWidth"}
    />
  );
});
